// extracted by mini-css-extract-plugin
export default {"menu_submenu_item_circle":"Aside_menu_submenu_item_circle__jyWTs"};